import type { IntlShape } from 'react-intl';
import type { LyricSection } from 'fym-shared/src/music24/lyricSections';
import { lyricPanelMessages } from './lyricPanelMessages';

/** The name of a section: its label, else "Part n" (n counts the sections with no label). */
export function sectionName(intl: IntlShape, sections: ReadonlyArray<LyricSection>, index: number): string {
  const section = sections[index];
  if (section === undefined) {
    return '';
  }
  if (section.label !== null) {
    return section.label;
  }
  const number = sections.slice(0, index + 1).filter((item) => item.label === null).length;
  return intl.formatMessage(lyricPanelMessages.part, { number });
}
